const pinsuccess = {
  methods: {
    goPageLogin () {
      this.$router.push('/auth/login')
    }
  }
}
export default pinsuccess
